export type UiState = {
  storeName: {
    value: string
    errors: string[]
  }
  lastName: {
    value: string
    errors: string[]
  }
  firstName: {
    value: string
    errors: string[]
  }
  email: {
    value: string
    shouldCheckFormat: boolean // メールアドレスの形式チェックをフォーム入力完了後のみ表示するためのboolean。
    errors: string[]
  }
  phone: {
    value: string
    errors: string[]
  }
}

export const initialUiState: UiState = {
  storeName: {
    value: '',
    errors: [],
  },
  lastName: {
    value: '',
    errors: [],
  },
  firstName: {
    value: '',
    errors: [],
  },
  email: {
    value: '',
    shouldCheckFormat: false,
    errors: [],
  },
  phone: {
    value: '',
    errors: [],
  },
}
